import React from "react";
import { Star } from "lucide-react";
import { testimonials } from "../data";


export default function Social() {
  return (
    <section className="social" id="social">
      <div className="container">
        <div className="section-label">Нам доверяют</div>
        <h2 className="section-title">Реальные истории пациентов</h2>
        <p className="section-subtitle">
          Мы публикуем только честные отзывы. Посмотрите, что говорят пациенты после лечения.
        </p>

        <div className="testimonials-row">
          {testimonials.map((t, i) => (
            <div key={i} className="testimonial-card" data-testid={`testimonial-${i}`}>
              <div className="testimonial-stars">
                {Array.from({ length: t.rating }).map((_, s) => (
                  <Star key={s} size={16} fill="currentColor" />
                ))}
              </div>
              <p className="testimonial-text">«{t.text}»</p>
              <div className="testimonial-meta">
                <div className="testimonial-author">
                  {t.name}
                  <span>· {t.age}</span>
                </div>
                <div className="testimonial-service">{t.service}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
